import ThemeModal from "components/Common/ThemeModal"
import { Badge, Button, Table } from "reactstrap"
import { useWorkOrder } from "hooks/useWorkOrder"
import { formatReadableDate } from "utils/formatDate"

const statusBadge = status => {
  const map = {
    pending: "warning",
    in_progress: "info",
    completed: "success",
    cancelled: "secondary",
  }
  return (
    <Badge className={`badge-soft-${map[status] || "light"}`}>
      {status?.replace("_", " ") || "-"}
    </Badge>
  )
}

const WorkOrderView = ({ workOrderId, isOpen, toggle, onChanged }) => {
  const { data: response, isLoading } = useWorkOrder(workOrderId, isOpen)

  const order = response?.data || {}

  return (
    <ThemeModal
      isOpen={isOpen}
      toggle={() => {
        toggle()
        onChanged?.()
      }}
      title={`Work Order: ${order.work_order_no || ""}`}
      size="lg"
    >
      {isLoading ? (
        <div className="text-center py-4">Loading...</div>
      ) : (
        <>
          <Table bordered className="mb-3">
            <tbody>
              <tr>
                <th className="w-25">Work Order #</th>
                <td className="w-25">{order.work_order_no || "-"}</td>
                <th className="w-25">Status</th>
                <td className="w-25">{statusBadge(order.status)}</td>
              </tr>
              <tr>
                <th>Vehicle</th>
                <td colSpan={3}>
                  {order.vehicle
                    ? `${order.vehicle.stock_id || ""} ${order.vehicle.brand?.name || ""} ${order.vehicle.model?.name || ""}`.trim() || "-"
                    : "-"}
                </td>
              </tr>
              <tr>
                <th>Assigned Date</th>
                <td>
                  {order.assigned_date
                    ? formatReadableDate(order.assigned_date)
                    : "-"}
                </td>
                <th>Completed Date</th>
                <td>
                  {order.completed_date
                    ? formatReadableDate(order.completed_date)
                    : "-"}
                </td>
              </tr>
              <tr>
                <th>Money Receipt</th>
                <td colSpan={3}>
                  {order.money_receipt
                    ? `${order.money_receipt.mr_no || ""} - ${order.money_receipt.customer?.name || ""}`.trim() || "-"
                    : "-"}
                </td>
              </tr>
              {order.notes && (
                <tr>
                  <th>Notes</th>
                  <td colSpan={3}>{order.notes}</td>
                </tr>
              )}
            </tbody>
          </Table>

          <h6 className="mb-2">Items</h6>
          <Table bordered size="sm">
            <thead>
              <tr>
                <th>#</th>
                <th>Service</th>
                <th>Employee</th>
                <th>Vendor/Work Shop/Garage/Shop</th>
                <th>Status</th>
                <th>Due</th>
                <th>Completed</th>
                <th>Notes</th>
              </tr>
            </thead>
            <tbody>
              {order.items?.length > 0 ? (
                order.items.map((item, idx) => (
                  <tr key={item.id || idx}>
                    <td>{idx + 1}</td>
                    <td>{item.service_list?.name || "-"}</td>
                    <td>
                      {item.employee?.name || "-"}
                      {item.employee?.designation?.title
                        ? ` (${item.employee.designation.title})`
                        : ""}
                    </td>
                    <td>{item.vendor?.name || "-"}</td>
                    <td>{statusBadge(item.status)}</td>
                    <td>
                      {item.due_date
                        ? formatReadableDate(item.due_date)
                        : "-"}
                    </td>
                    <td>
                      {item.completed_date
                        ? formatReadableDate(item.completed_date)
                        : "-"}
                    </td>
                    <td>{item.notes || "-"}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={8} className="text-center">
                    No items
                  </td>
                </tr>
              )}
            </tbody>
          </Table>

          <div className="text-end">
            <Button color="secondary" onClick={toggle}>
              Close
            </Button>
          </div>
        </>
      )}
    </ThemeModal>
  )
}

export default WorkOrderView
